import api, { unwrap } from './client';
import type { ApiResponse, PageResponse, SearchParams } from '@/types/api';
import type { PermissionResponse } from '@/types/role';

export const permissionsApi = {
  list: (params?: SearchParams) =>
    unwrap(api.get<ApiResponse<PageResponse<PermissionResponse>>>('/v1/permissions', { params })),

  /** Fetches every permission page so matrix rows are not dropped past the first page. */
  listAll: async (params?: Omit<SearchParams, 'page'>) => {
    const all: PermissionResponse[] = [];
    let page = 0;
    let last = false;
    while (!last) {
      const res = await permissionsApi.list({ ...params, size: 500, page });
      all.push(...res.content);
      last = res.last ?? page + 1 >= (res.totalPages ?? 1);
      page += 1;
    }
    return all;
  },
};
